import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { addPostApi } from '../../../../api/post';
import { getAccessTokenApi } from '../../../../api/auth';
import { errorModal, successModal, warningModal, infoModal } from '../../../Alerts/Alerts';
import $ from 'jquery';
import 'popper.js';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'summernote/dist/summernote-bs4';
import 'summernote/dist/summernote-bs4.css';
import 'summernote-ext-print';

export default function NewPostForm(props) {
    const { categories, 
            subcategories, 
            setReloadCat, 
            setReloadSubCat, 
            post,
            newSubcategory
          } = props;
	  const [ tagsData, selectedTags ] = useState([]);
    const [ postData, setPostData ] = useState({});
    const [ urlData, setUrlData ] = useState('');
    const [ titleData, setTitleData ] = useState('');
    const [ contentData, setContentData ] = useState('');
    const history = useHistory();
    let auxTag = [];

    useEffect(() => {
        if(post){
            setPostData(post);
            setContentData(post.gl_contenido);
            post.id_etiqueta.forEach(element => {
              auxTag.push(element.nm_etiqueta)
            });
            selectedTags(auxTag);
        }else{
            setPostData({});
            selectedTags([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [post]);

    const publishPost = () => {
      postData.id_estado = 'Publicado';
      processPost();
    }

    const savePost = () => {
      postData.id_estado = 'Borrador';
      processPost();
    }

    const processPost = () => {
        postData.id_usuario = localStorage.getItem('id');

        if(!postData.id_categoria){
            postData.id_categoria = categories[0]._id;
        }
        
        if(!postData.id_subcategoria){
          if (postData.id_categoria){
            let tmpSubCat = subcategories.filter(subcat => subcat.id_categoria === postData.id_categoria);
            if(tmpSubCat.length === 0){
              warningModal("Advertencia", "Sin subcategoria en la selección realizada, favor crear una.");
              postData.id_subcategoria = '';
            }else{
              postData.id_subcategoria = tmpSubCat[0]._id;
            }
          }else{
            let tmpSubCat = subcategories.filter(subcat => subcat.id_categoria === categories[0]._id);
            postData.id_subcategoria = tmpSubCat[0]._id;
          }
        }

        if(tagsData && tagsData.length > 0){
          postData.nm_tags = tagsData;
        }

        if(urlData && urlData !== ''){
          postData.url = urlData;
        }

        if(titleData && titleData !== ''){
          postData.nm_titulo = titleData;
        }

        if(contentData){
          postData.gl_contenido = contentData;
        }

        const { nm_titulo, url, gl_contenido, nm_tags, id_categoria, id_subcategoria } = postData;
    
        if (!nm_titulo || !url || !gl_contenido || !nm_tags || !id_categoria || !id_subcategoria) {
          warningModal("Advertencia", "Todos los campos son obligatorios.");
        } else {
          addPost();
        }
    };

    const addPost = () => {
      const token = getAccessTokenApi();
      addPostApi(token, postData)
        .then(response => {
          if(response.code === 200){
            setPostData({});
            selectedTags([]);
            setTitleData('');
            setUrlData('');
            successModal("", response.message);
            history.push("/admin/publication");
          }else{
            infoModal("Información", response.message);
          }
        })
        .catch(() => {
          errorModal	("Error", "Error del Servidor.");
        });
    };

    const previewPost = () => {
      var content = $('#summernote').summernote()[0].value;
      var html = '<html><head><title>Vista Previa Publicación</title></head><body>'+content+'</body></html>';
      var newWindow = window.open();
      newWindow.document.write(html);
    }

    const addTags = event => {
      if (event.key === "Enter" && event.target.value !== "") {
        selectedTags([...tagsData, event.target.value]);
        selectedTags([...tagsData, event.target.value]);
        event.target.value = "";
      }
    };
    const removeTags = index => {
      selectedTags([...tagsData.filter(tag => tagsData.indexOf(tag) !== index)]);
    };

    const handleClickSub = (e) => {
      e.preventDefault();
      newSubcategory();      
    }

    const handleChangeUrl = e => {
      let url = transformTextToUrl(e.target.value);
      setUrlData(url);
      e.target.value = url;
    }

    const handleChangeTag = e => {
      let txt = transformTextNoSpChar(e.target.value);
      e.target.value = txt;
    }

    $('#summernote').summernote({
        tabsize: 2,
        height: 410,
        toolbar: [
            [ 'misc', ['undo', 'redo']],
            [ 'fontsize', ['fontname', 'fontsize', 'style']],
            [ 'style', ['bold', 'underline', 'italic', 'strikethrough']],
            [ 'font', ['subscript', 'superscript']],
            [ 'color', ['color']],
            [ 'format', ['clear']],
            [ 'para', ['paragraph', 'hr', 'ol', 'ul', 'height', 'table']],
            [ 'insert', ['link', 'picture', 'video']],
            [ 'misc', ['print']],
            [ 'view', ['fullscreen', 'codeview', 'help']]
        ],
        popover: {
            image: [
              ['image', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
              ['float', ['floatLeft', 'floatRight', 'floatNone']],
              ['remove', ['removeMedia']]
            ],
            link: [
              ['link', ['linkDialogShow', 'unlink']]
            ],
            table: [
              ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
              ['delete', ['deleteRow', 'deleteCol', 'deleteTable']],
            ],
            air: [
              ['color', ['color']],
              ['font', ['bold', 'underline', 'clear']],
              ['para', ['ul', 'paragraph']],
              ['table', ['table']],
              ['insert', ['link', 'picture']]
            ]
          },
          callbacks: {
            onChange: function(contents, $editable) {
              setContentData(contents);
            }
          }
    });

    return (
        <div className="col-12">
          <div className="row">
            <div className="col-10">
              <h1 className="h3 mb-4 text-gray-800">
                Nueva Publicación
                <span>
                    <button className="btn btn-primary float-right" onClick={previewPost}>Vista Previa</button>
                </span>
              </h1>
                <div className="row">
                  <div className="col-12 align-content-end">
                    <div className="row">
                      <div className="col-6 align-content-end">
                        <input 
                            type="text" 
                            className="form-control" 
                            placeholder="Título de la publicación"
                            onChange={e => setTitleData(e.target.value)}
                        />
                      </div>
                      <div className="col-6 align-content-end">
                        <input 
                          type="text" 
                          className="form-control" 
                          placeholder="Url publicación" 
                          onChange={handleChangeUrl}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-12 align-content-end">
                    <div className="card w-100 h-100">

                      <textarea
                        id="summernote" 
                        name="editordata"
                      />

                    </div>
                  </div>
                </div>
              </div>
              <div className="col-2">
                <div className="row">
                  <div className="col-12 p-0 card">
                    <div className="card-header py-3">
                      <h6 className="m-0 font-weight-bold text-primary">Publicar</h6>
                    </div>
                    <div className="card-body p-3">
                      <div className="row">
                        <div className="col-12">
                          <label ><strong>Estado:</strong> <span className="ml-1">Borrador</span></label>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <button className="btn btn-danger text-white" onClick={savePost}>Guardar</button>
                        </div>
                        <div className="col-6">
                          <button className="btn btn-success text-white" onClick={publishPost}>Publicar</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-12 p-0 card">
                    <div className="card-header py-3">
                      <h6 className="m-0 font-weight-bold text-primary">Categorías</h6>
                    </div>
                    <div className="card-body pt-1 pb-3 pr-3 pl-3">
                      <Categories 
                        categories={categories} 
                        setReloadCat={setReloadCat} 
                        postData={postData} 
                        setPostData={setPostData}
                      />
                    </div>
                    <div className="card-body pt-1 pb-3 pr-3 pl-3">
                      <Subcategories 
                          setReloadSubCat={setReloadSubCat} 
                          postData={postData}
                          setPostData={setPostData}
                          categories={categories}
                          subcategories={subcategories}
                      />
                    </div>
                    <div className="card-body pt-1 pb-3 pr-3 pl-3">
                      <Link to={""} onClick={handleClickSub}>+ Agregar subcategoría</Link>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-12 p-0 card">
                    <div className="card-header py-3">
                      <h6 className="m-0 font-weight-bold text-primary">Etiquetas</h6>
                    </div>
                    <div className="card-body p-3">

                      {tagsData.map((tag, index) => (
                        <li key={index} className="badge badge-info mr-1">
                            {tag}
                            <span style={{"color": "white", "cursor": "pointer"}} onClick={() => removeTags(index)}><i className="fas fa-times ml-2"></i></span>
                        </li>
                      ))}
                      <input
                          type="text"
                          className="form-control  pl-1 pr-1" 
                          onKeyUp={event => addTags(event)}
                          placeholder="Enter para agregar"
                          maxLength="80"
                          onChange={handleChangeTag}
                      />

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
    )
}

function Categories (props) {
  const { categories, setPostData, postData } = props;

  return (
    <>
      <label >Categoría Principal</label>
      <select 
          className="form-control p-1"
          value={postData.id_categoria && postData.id_categoria._id}
          onChange={e => setPostData({ ...postData, id_categoria: e.target.value })}
      >
        {categories && categories.map((cat, index) => (
          <option key={index} value={cat._id}>{cat.nm_categoria}</option>
        ))}
      </select>
    </>
  )
}

function Subcategories (props) {
  const { postData, setPostData, subcategories, categories } = props;
  let subcatFiltered = [];

  if(postData.id_categoria){
    subcatFiltered = subcategories.filter(subcat => subcat.id_categoria === postData.id_categoria);
  }else{
    if(categories && categories.length > 0){
      subcatFiltered = subcategories.filter(subcat => subcat.id_categoria === categories[0]._id);
    }
  }
  
  return (
    <>
      <SubcatDeta
        subcatFiltered={subcatFiltered}
        postData={postData}
        setPostData={setPostData}
      />
    </>
  )
}

function SubcatDeta (props) {
  const { subcatFiltered, postData, setPostData } = props;

  return (
    <>
      <label >Subcategoría</label>
      <select 
          className="form-control p-1"
          value={postData.id_subcategoria && postData.id_subcategoria._id}
          onChange={e => setPostData({ ...postData, id_subcategoria: e.target.value })}
      >
        {subcatFiltered && subcatFiltered.map((subcat, index) => (
          <option key={index} value={subcat._id}>{subcat.nm_subcategoria}</option>
        ))}
      </select>
    </>
  )

}

function transformTextToUrl(text) {
  const url = text
        .replace(" ", "-")
        .replace(/[ÁÀÄ]/g,"A")
				.replace(/[áàä]/g,"a")
				.replace(/[ÉÈË]/g,"E")
				.replace(/[éèë]/g,"e")
				.replace(/[ÍÌÏ]/g,"I")
				.replace(/[íìï]/g,"i")
				.replace(/[ÓÒÖ]/g,"O")
				.replace(/[óòö]/g,"o")
				.replace(/[ÚÙÜ]/g,"U")
				.replace(/[úùü]/g,"u")
				.replace(/[Ç]/g,"C")
				.replace(/[ç]/g,"c")
				.replace(/[Ñ]/g,"N")
				.replace(/[ñ]/g,"n")
        .replace(/[^a-zA-Z0-9-]/g, '');
  return url.toLowerCase();
}

function transformTextNoSpChar(text) {
  const txt = text
				.replace(/[ÁÀÄ]/g,"A")
				.replace(/[áàä]/g,"a")
				.replace(/[ÉÈË]/g,"E")
				.replace(/[éèë]/g,"e")
				.replace(/[ÍÌÏ]/g,"I")
				.replace(/[íìï]/g,"i")
				.replace(/[ÓÒÖ]/g,"O")
				.replace(/[óòö]/g,"o")
				.replace(/[ÚÙÜ]/g,"U")
				.replace(/[úùü]/g,"u")
				.replace(/[Ç]/g,"C")
				.replace(/[ç]/g,"c")
				.replace(/[Ñ]/g,"N")
				.replace(/[ñ]/g,"n")
				.replace(/[^a-zA-Z0-9]/g, '');
  return txt;
}